import React, { PropsWithChildren, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

export function Portal({
  children,
  targetId,
  triggerRender,
}: PropsWithChildren<{
  targetId: `wk-portal-target:${string}`;
  triggerRender?: unknown;
}>) {
  const TARGET_ID_PREFIX = 'wk-portal-target:';

  const [targetElement, setTargetElement] = useState(getElementById(targetId));

  useEffect(() => {
    setTargetElement(getElementById(targetId));
  }, [targetId, triggerRender]);

  if (!targetId?.startsWith(TARGET_ID_PREFIX)) {
    console.error(
      `Portal Error: target id must starts with '${TARGET_ID_PREFIX}'`
    );

    return null;
  }

  return (
    <span className="wk-portal">
      {targetElement && createPortal(children, targetElement, targetId)}
    </span>
  );
}

function getElementById(id: string) {
  return document.getElementById(id);
}
